module.exports = __webpack_public_path__ + "img/logo-c.23a1777a.jpg";